import { Typography } from '@mui/material';
import { get } from 'lodash';
import { ComponentType, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { io } from 'socket.io-client';
import { REACT_APP_IO_URL } from 'src/constants/base';
import { ROUTES } from '../../../constants/routes';
import { AttestationStatus } from '../../../enums/application-status.enum';
import { useRouter } from '../../../hooks';
// import { Loader } from '../../loader';
import { Page } from '../../page';
import { TestExam } from '../test-exam';
import { TestWait } from '../test-wait';

const token = localStorage.getItem('AUTH_TOKEN_KEY');

const socket = io(REACT_APP_IO_URL + '/api/socket/attestation', {
  // @ts-ignore
  // namespace: 'api/socket/attestation',
  reconnectionDelayMax: 10000,
  transports: ['websocket'],
  autoConnect: false,
  auth: {
    token,
  },
});

export const TestRoom: ComponentType = () => {
  const router = useRouter();
  const { t } = useTranslation();

  const [data, setData] = useState({});
  const attestationStatus = get(data, ['attestationStatus']);
  const id = get(data, ['id']);

  useEffect(() => {
    socket.connect();
    socket.on('connect', () => {
      console.log('connected');
    });
    socket.on('disconnect', () => {
      console.log('disconnected');
    });

    socket.on('current', (data: any) => {
      setData(data);
    });
  }, []);

  const handleFinish = () => {
    const path = ROUTES.TEST.RESULT.replace(':id', id);
    router.push(path);
  };

  if (attestationStatus === AttestationStatus.STOPPED) {
    return (
      <Page title={t('testing.stopped', 'Тестирование остановлено')}>
        <Typography variant="body2" component="span">
          {t('stoppedReasonLabel')}
        </Typography>
        :&nbsp;
        <Typography variant="body2" component="span" fontWeight={600}>
          {get(data, ['stoppedReason'])}
        </Typography>
      </Page>
    );
  }

  if (attestationStatus === AttestationStatus.STARTED && data) {
    return (
      <Page title={t('testing', 'Тестирование')} layout="empty">
        <TestExam onFinish={handleFinish} data={data} />
      </Page>
    );
  }

  return (
    <Page title={t('testing', 'Тестирование')}>
      <TestWait data={data} />
    </Page>
  );
};
